<template>
  <div>
    <div class="content-block-title">
      <span class="hide-in-modal">{{$lang.messages.sites.title}}</span>
      <span class="hide-in-menu">Add sites and applications to allow kids</span>
    </div>
    <div v-if="showInfoBlock" class="info-block flex-v-center hide-in-modal mobile-hidden">
      <button @click="showInfoBlock = false" class="btn-close btn-icon"><i class="icon-close-small"></i></button>
      <img src="../assets/img/did-you-know.svg" alt="did you know" class="mr-1">
      <div class="info-block-text">
        {{$lang.messages.sites.sites_description}}
      </div>
    </div>
    <div class="row mt-3 mb-2 hide-in-modal">
      <div class="col-md-6">
        <div class="flex-reverse-xs">
          <Checkbox :checkboxModel="{'allowKidRequestSite':profile.allowKidRequestSite}" @changecheckbox="allowRequests"/>
          <span class="ml-1 ml-0-xs mr-auto-xs content-block-subtitle"> {{$lang.messages.sites.allow_kid_to_request}}</span>
        </div>
      </div>
      <div class="col-md-6">
        <p class="text-muted">
          {{$lang.messages.sites.allow_kid_to_request_desc}}
        </p>
      </div>
    </div>
    <hr class="hide-in-modal">
    <div class="flex-between mt-2 mb-1">
      <p class="text-lg text-bold hide-in-modal mb-xs-1">{{$lang.messages.app.links.add_sites_to_allow}}</p>
      <p class="mb-1 ml-1 text-muted mobile-hidden">{{$lang.messages.app.links.add_sites_to_allow_description}}</p>
    </div>
    <div class="flex-between flex-v-top mb-2 flex-column-xs">
      <div class="mb-xs-1">
        <label for="allowAllSites" class="checkbox-custom flex-v-center mb-1">
          <input type="checkbox" id="allowAllSites" :checked="profile.allowAllLinks" @change="toggleAllLinks">
          <span class="checkmark mr-1"></span>
          <span class="checkbox-custom-title">Allow all sites</span>
        </label>
        <div class="w-100" v-if="profile.allowAllLinks">* it will give access to all sites</div>
      </div>
      <div class="flex">
        <span class="btn btn-outline mr-1" @click="showAddLinkDialog()">Add sites</span>
        <button class="btn btn-outline" @click="openAddApp">Add apps</button>
      </div>
    </div>
    <div class="text-bold mb-05">Websites</div>
    <div class="links-wrapper mb-2" :class="{'mb-1': profile.appListings}">
      <Link
          v-for="link in profile.links"
          :key="link.id"
          v-bind="link"
          v-on:removelink="removeLink"
          v-on:editlink="editLink"
      />
    </div>
    <div class="text-bold mb-05" v-if="profile.appListings">Applications</div>
    <div class="links-wrapper mb-2" v-if="profile.appListings">
      <AppItem
          v-for="app in profile.appListings"
          :key="app.packageName"
          v-bind="app"
          v-on:removeapp="removeApp"
          v-on:editapp="openAddApp"
      />
      <hr class="mb-2">
    </div>
    <div class="content-block-subtitle mt-2 hide-in-modal">{{$lang.messages.sites.useful_websites}}</div>
    <div class="shortcut-tabs-wrapper">
      <div class="shortcuts-tabs">
        <div v-for="(item, index) in categories" :key="index" class="radio-label shortcut-tab-item"
             :class="{active: activeTab === item}"
             @click="activeTab = item"
        >
          {{item}}
        </div>
      </div>
      <div class="shortcut-tabs-data">
        <div class="popup-link-list">
          <div :key="index"
               v-for="(link, index) in activeList"
               class="popup-link flex flex-v-top">
            <div class="popup-link-icon">
              <img :src="'https://www.google.com/s2/favicons?sz=64&domain=' + link.url" :alt="link.title">
            </div>
            <div class="popup-link-content">
              <div class="popup-link-header flex-between">
                <a :href="link.url" target="_blank" class="popup-link-title text-md">
                  {{link.title}}
                </a>
              </div>
              <div class="popup-link-text text-sm" :title="link.desc">
                {{link.desc}}
              </div>
            </div>
            <div class="popup-link-btn" @click="addLinkFromList(link)">+</div>
          </div>
        </div>
      </div>
    </div>
    <AddLinkModal
        :linktitle="editLinkTitle"
        :linkurl="editLinkUrl"
        :linkId="editLinkId"
        :isEdit="editLinkId"
        :kidAge="profile.kidage"
        :recommended="false"
        v-if="showAddLinkModal"
        v-on:addlink="addLink"
        v-on:removelink="removeLink"
        v-on:hidemodal="showAddLinkModal = false"/>
    <div v-if="showAlreadyExistLinkModal" class="modal" @click.self="showAlreadyExistLinkModal = false">
      <div class="modal-dialog modal-dialog-sm">
        <div class="modal-title">{{$lang.messages.sites.oops}} <span class="modal-close" @click="showAlreadyExistLinkModal = false"><i class="icon-close"></i></span></div>
        <div class="modal-content">
          <div>
            <p>{{$lang.messages.url_exists}}</p>
            <p class="recommended -small"><span class="recommended-title">{{alreadyExistLinkUrl}}</span></p>
            <p>{{$lang.messages.links_list}}</p>
          </div>
        </div>
        <div class="modal-footer text-right">
          <button class="btn btn-main" @click="showAlreadyExistLinkModal = false">{{$lang.messages.ok}}</button>
        </div>
      </div>
    </div>
    <AddDevice v-if="addDeviceShow" v-on:closepopup="addDeviceShow = false" defaultOpenScreen="mobile"/>
  </div>
</template>

<script>
import Checkbox from './Checkbox';
import AddLinkModal from './AddLinkModal';
import Link from './Link';
import {recommendedLinks, notAvailableForMobileDomains, recommendedLinksCategories, recommendedLinksPopup} from "../helpers/configs";
import {reportEvent} from "@/helpers/utils";
import saveSetting from './mixins/saveSetting'
import {mapState} from "vuex";
import AddDevice from "@/components/AddDevice";
import AppItem from "@/components/AppItem";

export default {
  mixins: [saveSetting],
  name: 'Sites',
  props: ['profileId', 'profile'],
  data: function (){
    return {
      isAndroid: window.Android,
      maxLinks: 10,
      showAddLinkModal: false,
      alreadyExistLinkUrl: '',
      showAlreadyExistLinkModal: false,
      showInfoBlock: true,
      editLinkTitle: '',
      editLinkUrl: '',
      editLinkId: null,
      recommendedLinks,
      addDeviceShow: false,
      categories: recommendedLinksCategories,
      recommendedLinksPopup,
      activeTab: 'Education',
    }
  },
  computed: {
    recommendedList () {
      let removeFromRecommended = []
      if (this.profile.userRemovedRecommended) {
        this.profile.userRemovedRecommended.forEach(link => removeFromRecommended.push(link));
        const isAndroid = window.Android;
        return this.recommendedLinks.filter((item) => {
          const notInRemovedRecommended = !removeFromRecommended.includes(item.url);
          if (!isAndroid) {
            return notInRemovedRecommended;
          }
          return notInRemovedRecommended && !notAvailableForMobileDomains.includes(item.url);
        })
      }
      return this.recommendedLinks;
    },
    isGuestProfile() {
      return this.profileId === 'guestProfileAtCurrentDevice';
    },
    activeList() {
      const isAlreadyInSelected = this.profile.links.map(link => link.url);
      return this.recommendedLinksPopup.filter(link => link.category === this.activeTab && (link.age === this.kidAge || link.age === 'all') && !isAlreadyInSelected.includes(link.url));
    },
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    allowRequests(keyName, value) {
      this.saveProfileSettings(this.profileId, {
        allowKidRequestSite: value,
      });
    },
    toggleAllLinks(e) {
      this.saveProfileSettings(this.profileId, {
        allowAllLinks: e.target.checked,
      });
    },
    openAddApp() {
      if (this.isAndroid) {
        this.isAndroid.onClickAddPhoneApps(this.profileId);
      } else  {
        this.addDeviceShow = true;
      }
    },
    sendTestNotification () {
      const browser = window.browser || window.chrome;
      if (browser) {
        browser.runtime.sendMessage(localStorage.getItem('extID'), {sendTestNotification: true});
      } else {
        window.postMessage({
          direction: 'from-page-script',
          message: 'test notification',
        }, "*");
      }
    },
    updateSettings(keyName, value){
      this.$emit('updatesettings', {[keyName]: value})
    },
    removeLink (link) {
      if (this.profile.links.length > 1) {
        const clearedLinks = this.profile.links.filter(item => item.id !== link);
        this.saveProfileSettings(this.profileId,{links: clearedLinks});
        reportEvent('kidsModeLink', {remove: true})
      } else {
        this.$dtoast.pop({
          preset: "error",
          heading: "You should have at least one site",
        });
      }
    },
    removeApp (name) {
        const clearedApps = this.profile.appListings.filter(item => item.packageName !== name);
        this.saveProfileSettings(this.profileId,{appListings: clearedApps});
        reportEvent('kidsModeLink', {remove: true, app: true})
    },
    checkDuplicateLink(url) {
      const index = this.profile.links ? this.profile.links.findIndex(item => item.url === url) : null
      return index !== -1
    },
    addLink(link, editLinkId) {
      this.showAddLinkModal = false
      if (this.profile.links && editLinkId) {
        const item = this.profile.links.find(item => item.id === editLinkId);
        if (this.checkDuplicateLink(link.url) && item.title === link.title) {
          this.$dtoast.pop({
            preset: "error",
            heading: `The site ${link.url} already in list`,
          });
        } else {
          Object.assign(item, link);
          this.editLinkId = false;
          this.saveProfileSettings(this.profileId,{links: [...this.profile.links]});
          reportEvent('kidsModeLink', {edit: true})
        }
      } else {
        if (this.checkDuplicateLink(link.url)) {
          this.$dtoast.pop({
            preset: "error",
            heading: `The site ${link.url} already in list`,
          });
        } else {
          this.saveProfileSettings(this.profileId,{links: [...this.profile.links, link]});
          reportEvent('kidsModeLink', {add: true})
        }
      }
    },
    editLink (link) {
      this.editLinkTitle = link.title
      this.editLinkUrl = link.url
      this.editLinkId = link.id
      this.showAddLinkModal = true
    },
    removeRecommendedlink (link) {
      const removedCopy = this.profile.userRemovedRecommended ?
          [...this.profile.userRemovedRecommended, link.url] : [link.url];
      this.saveProfileSettings(this.profileId,  {userRemovedRecommended: removedCopy})
    },
    showAddLinkDialog () {
      this.editLinkTitle = ''
      this.editLinkUrl = 'https://'
      this.editLinkId = null
      this.showAddLinkModal = true
    },
    addLinkFromList(item){
      const { hostname } = new URL(item.url)
      const icon = 'https://www.google.com/s2/favicons?sz=64&domain=https://'+hostname+''
      const link = {
        id: Date.now(),
        title: item.title,
        url: item.url,
        icon: icon
      }
      this.addLink(link)
    },
  },
  components: {
    AppItem,
    AddLinkModal,
    Checkbox,
    Link,
    AddDevice
  }
}
</script>


